module.exports = __webpack_public_path__ + "img/curtain_up_30.e2bd9cdf.svg";